import React from "react";
import { Drawer, Card, notification, Button, Tooltip, Icon, Alert } from "antd";
import { TableComp } from "sz-react-utils";
import Request, { MEDIA_URL } from "../../request";
import moment from "moment";

class InvoiceApprovalDrawer extends React.Component {
    state = {
        visible: true,
        count: 0,
        loading: false
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }


    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getInvoiceApprovalRequests(params);
            this.setState({ count: response.total });
            return resolve(response);
        })
    }

    updateRequestStatus = async (recordId, status) => {
        this.setState({ loading: true });
        let disapproveReason = null;
        if (status === "Disapproved") {
            disapproveReason = prompt('Reason of Disapproval');
        }

        if (status === "Disapproved" && !disapproveReason) {
            notification.error({
                message: 'Add Reason For Disapprove'
            });
            this.setState({ loading: false });
            return
        }
        let response = await Request.updateInvoiceApprovalRequest({ _id: recordId, invoiceApprovalStatus: status, disapproveReason });
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }

        this.table.current.reload();
    }

    render() {
        let { visible, count, loading } = this.state;
        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };
        const columns = [
            {
                title: 'S. No',
                key: 'serialNumber',
                width: 70,
                align: 'center',
                render: (text, record, index) => (
                    <div style={{ fontWeight: 600, color: '#666' }}>
                        {index + 1}
                    </div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                width: 100,
                align: 'center',
                render: (text, record) => (
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <Tooltip title="Approve Request">
                            <Button
                                loading={loading}
                                shape="circle"
                                icon="check"
                                size="small"
                                type="primary"
                                style={{ background: '#52c41a', borderColor: '#52c41a' }}
                                onClick={() => this.updateRequestStatus(record._id, "Approved")}
                            />
                        </Tooltip>
                        <Tooltip title="Disapprove Request">
                            <Button
                                loading={loading}
                                shape="circle"
                                icon="close"
                                size="small"
                                type="danger"
                                onClick={() => this.updateRequestStatus(record._id, "Disapproved")}
                            />
                        </Tooltip>
                    </div>
                )
            },
            {
                title: 'Invoice Details',
                key: 'invoiceDetails',
                searchTextName: 'Invoice Details',
                width: 280,
                render: (text, record) => {
                    var invNum = record && record.invoiceNumber ? record.invoiceNumber : '-';
                    var invType = record && record.invoiceType ? record.invoiceType : '-';
                    var invStatus = record && record.invoiceStatus ? record.invoiceStatus : 'PENDING';
                    var approvalStatus = record && record.invoiceApprovalStatus ? record.invoiceApprovalStatus : '-';
                    var commissionGrandTotal = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;

                    var invoiceCurrency = record && record.invoices && record.invoices.length > 0 && record.invoices[0].currency ? record.invoices[0].currency : 'EUR';
                    var invoiceSymbol = currencySymbols[invoiceCurrency] ? currencySymbols[invoiceCurrency] : invoiceCurrency + ' ';

                    var createdUser = record && record.createdByUser ? record.createdByUser : null;
                    var createdByName = createdUser && createdUser.name ? createdUser.name : '-';

                    var invDate = record && record.invoiceGeneratedDate ? record.invoiceGeneratedDate : null;
                    var formattedGenDate = '-';
                    if (invDate) {
                        var rawGenDate = invDate.$date ? invDate.$date : invDate;
                        formattedGenDate = moment(rawGenDate).format('DD.MM.YYYY');
                    }

                    var getStatusColors = function (currentStatus) {
                        var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
                        var config = {
                            'PENDING': { color: '#d48806', bg: '#fffbe6', border: '#ffe58f' },
                            'CLEARED': { color: '#237804', bg: '#f6ffed', border: '#95de64' },
                            'APPROVED': { color: '#389e0d', bg: '#f6ffed', border: '#b7eb8f' },
                            'PAID BY UNI': { color: '#531dab', bg: '#f9f0ff', border: '#d3adf7' }
                        };
                        return config[s] || { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' };
                    };

                    var mainStatusStyles = getStatusColors(invStatus);
                    var approvalStyles = getStatusColors(approvalStatus);

                    var invUrl = record && record.invoiceUrl ? record.invoiceUrl : null;
                    var receipts = record && record.paymentReceipt ? record.paymentReceipt : [];
                    var singleReceiptUrl = receipts.length > 0 && receipts[0].url ? receipts[0].url : null;

                    // ✅ Extracting Agreement and Agreement Commission files safely from data
                    var agreementArray = record && record.agreement ? record.agreement : [];
                    var agreementUrl = agreementArray.length > 0 && agreementArray[0].url ? agreementArray[0].url : null;

                    var agreementCommArray = record && record.agreementCommission ? record.agreementCommission : [];
                    var agreementCommUrl = agreementCommArray.length > 0 && agreementCommArray[0].url ? agreementCommArray[0].url : null;

                    return (
                        <div style={{
                            padding: '12px 14px',
                            background: '#fff',
                            borderRadius: '10px',
                            border: '1px solid #f0f0f0',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontWeight: 700, fontSize: '13px' }}>
                                    {record.invoiceUrl ? (
                                        <a
                                            href={`${MEDIA_URL}${record.invoiceUrl}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#096dd9', borderBottom: '1px dashed #096dd9', textDecoration: 'none' }}
                                        >
                                            Inv#: {invNum}
                                        </a>
                                    ) : (
                                        "Inv#: " + invNum
                                    )}
                                </span>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#595959',
                                    background: '#f5f5f5',
                                    padding: '3px 8px',
                                    borderRadius: '4px',
                                    border: '1px solid #e8e8e8'
                                }}>
                                    <Icon type="calendar" style={{ marginRight: 5, color: '#8c8c8c' }} />
                                    {formattedGenDate}
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                <div>
                                    <div style={{ fontSize: '16px', fontWeight: 800, color: '#141414', lineHeight: 1.2 }}>
                                        {invoiceSymbol}{Number(commissionGrandTotal).toFixed(2)}
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px' }}>
                                        Type: <strong style={{ color: '#595959' }}>{invType}</strong>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                                    <span style={{
                                        fontSize: '10px',
                                        fontWeight: 700,
                                        color: mainStatusStyles.color,
                                        background: mainStatusStyles.bg,
                                        border: '1px solid ' + mainStatusStyles.border,
                                        padding: '1px 8px',
                                        borderRadius: '12px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px'
                                    }}>
                                        {invStatus}
                                    </span>

                                    <span style={{
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        color: approvalStyles.color,
                                        background: approvalStyles.bg,
                                        border: '1px dashed ' + approvalStyles.border,
                                        padding: '1px 6px',
                                        borderRadius: '4px',
                                        textTransform: 'capitalize'
                                    }}>
                                        Appr: {approvalStatus}
                                    </span>
                                </div>
                            </div>

                            {/* Standard Invoice/Receipt Files Section */}
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '2px', fontSize: '11px', borderTop: '1px solid #f5f5f5', paddingTop: '6px' }}>
                                {invUrl && (
                                    <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#13c2c2' }}>
                                        <Icon type="file-pdf" style={{ marginRight: 2 }} /> Invoice File
                                    </a>
                                )}
                                {singleReceiptUrl && (
                                    <a href={`${MEDIA_URL}${singleReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1' }}>
                                        <Icon type="file-done" style={{ marginRight: 2 }} /> Receipt
                                    </a>
                                )}
                            </div>

                            {/* ✅ Added: Agreement & Agreement Commission document view layout links */}
                            {(agreementUrl || agreementCommUrl) && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', background: '#fafafa', padding: '6px', borderRadius: '4px', border: '1px dashed #e8e8e8', fontSize: '11px' }}>
                                    {agreementUrl && (
                                        <a href={`${MEDIA_URL}${agreementUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#fa8c16' }}>
                                            <Icon type="file-protect" style={{ marginRight: 4 }} /> View Agreement
                                        </a>
                                    )}
                                    {agreementCommUrl && (
                                        <a href={`${MEDIA_URL}${agreementCommUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#ff4d4f' }}>
                                            <Icon type="file-excel" style={{ marginRight: 4 }} /> View Comm. Structure List
                                        </a>
                                    )}
                                </div>
                            )}

                            <div style={{
                                marginTop: '2px',
                                fontSize: '11px',
                                color: '#8c8c8c'
                            }}>
                                <Icon type="user" style={{ marginRight: 4, color: '#bfbfbf' }} />
                                By: <span style={{ color: '#595959', fontWeight: 500 }}>{createdByName}</span>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Student & Course Details',
                key: 'studentCourseDetails',
                width: 340,
                render: (text, record) => {
                    var students = record && record.invoices ? record.invoices : [];

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {students.map((student, idx) => {
                                var studentConversion = student.conversionRate ? student.conversionRate : '-';
                                var studentCurrency = student.currency ? student.currency : 'EUR';
                                var sym = currencySymbols[studentCurrency] ? currencySymbols[studentCurrency] : studentCurrency + ' ';

                                var currentTerm = student.termNumber ? student.termNumber : '1';
                                var totalTerms = student.inquiry && student.inquiry.totalTerms ? student.inquiry.totalTerms : '1';
                                var studentId = student.studentId ? student.studentId : '';

                                // ─── ✅ 1. DATABASE PATH EXTRACTION PATHS ───────────────────────
                                var studentFeeReceiptArray = student && student.feeReceipt && student.feeReceipt.files ? student.feeReceipt.files : [];
                                var studentFeeReceiptUrl = studentFeeReceiptArray.length > 0 && studentFeeReceiptArray[0].url ? studentFeeReceiptArray[0].url : null;

                                var studentSwiftCopyArray = student && student.swiftCopy && student.swiftCopy.files ? student.swiftCopy.files : [];
                                var studentSwiftCopyUrl = studentSwiftCopyArray.length > 0 && studentSwiftCopyArray[0].url ? studentSwiftCopyArray[0].url : null;

                                return (
                                    <div key={idx} style={{
                                        padding: '10px',
                                        background: '#fafafa',
                                        borderRadius: '8px',
                                        border: '1px solid #f0f0f0',
                                        borderBottom: idx !== students.length - 1 ? '1px dashed #d9d9d9' : '1px solid #f0f0f0',
                                        lineHeight: '22px'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                            <span style={{ fontSize: '14px' }}>
                                                <Icon type="user" style={{ marginRight: 6, color: '#1677ff' }} />
                                                {studentId ? (
                                                    <a
                                                        href={`/desk/getClaim?id=${studentId}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ fontWeight: 700, color: '#1677ff', textDecoration: 'none', borderBottom: '1px dashed #1677ff' }}
                                                    >
                                                        {student.studentName}
                                                    </a>
                                                ) : (
                                                    <strong style={{ fontWeight: 700, color: '#262626' }}>{student.studentName}</strong>
                                                )}
                                            </span>

                                            <span style={{
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                color: '#096dd9',
                                                background: '#e6f7ff',
                                                border: '1px solid #91d5ff',
                                                padding: '1px 6px',
                                                borderRadius: '4px'
                                            }}>
                                                T{currentTerm} / T{totalTerms}
                                            </span>
                                        </div>

                                        <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                            <b>VID:</b> {student.studentVisionId} | <b>Passport:</b> {student.passportNumber}
                                        </div>

                                        <div style={{ fontWeight: 600, color: '#262626', marginTop: '4px' }}>
                                            <Icon type="bank" style={{ marginRight: 6, color: '#bfbfbf' }} />
                                            {student.universityInstitutionName || '-'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#595959', fontStyle: 'italic' }}>
                                            {student.courseName}
                                        </div>

                                        <div style={{
                                            marginTop: '6px',
                                            paddingTop: '4px',
                                            borderTop: '1px dashed #e8e8e8',
                                            fontSize: '11px',
                                            color: '#434343',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '2px'
                                        }}>
                                            <div><b>Tuition Fee:</b> {sym}{Number(student.tutionFee || 0).toFixed(2)}</div>
                                            <div><b>Commission:</b> {sym}{Number(student.commissionTotal || 0).toFixed(2)}</div>

                                            {/* ─── ✅ 2. DYNAMIC LINKS RENDERING HERE FOR FEE RECEIPT & SWIFT COPY ─── */}
                                            {(studentFeeReceiptUrl || studentSwiftCopyUrl) && (
                                                <div style={{
                                                    display: 'flex',
                                                    gap: '12px',
                                                    marginTop: '6px',
                                                    padding: '4px 6px',
                                                    background: '#fff',
                                                    borderRadius: '4px',
                                                    border: '1px solid #e8e8e8'
                                                }}>
                                                    {studentFeeReceiptUrl && (
                                                        <a href={`${MEDIA_URL}${studentFeeReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#2f54eb', fontWeight: 500 }}>
                                                            <Icon type="file-text" style={{ marginRight: 4 }} /> View Fee Receipt
                                                        </a>
                                                    )}
                                                    {studentSwiftCopyUrl && (
                                                        <a href={`${MEDIA_URL}${studentSwiftCopyUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1', fontWeight: 500 }}>
                                                            <Icon type="swap" style={{ marginRight: 4 }} /> View Swift Copy
                                                        </a>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
            },
            {
                title: 'Company Details',
                key: 'companyDetails',
                width: 240,
                render: (text, record) => (
                    <div style={{
                        lineHeight: '22px',
                        padding: '10px',
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                    }}>
                        <div style={{ fontWeight: 700, fontSize: '14px', color: '#262626', marginBottom: '6px' }}>
                            <Icon type="global" style={{ marginRight: 6, color: '#fa8c16' }} />
                            {record.invoiceToName}
                        </div>
                        <div style={{ fontSize: '12px', color: '#595959' }}>
                            <div><b>CP:</b> {record.kindAttention}</div>
                            <div><b>Email:</b> {record.invoiceToEmail}</div>
                            <div><b>Phone:</b> {record.invoiceToPhone}</div>
                            <div style={{ marginTop: '4px' }}>
                                <span style={{
                                    background: '#f5f5f5',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    border: '1px solid #d9d9d9',
                                    color: '#595959'
                                }}>
                                    {record.invoiceToCategory}
                                </span>
                            </div>
                        </div>
                    </div>
                )
            }
        ];
        // const columns = [
        //     {
        //         title: 'S. No',
        //         key: 'serialNumber',
        //         width: 70,
        //         align: 'center',
        //         render: (text, record, index) => {
        //             console.log(record);
        //             return (
        //                 <div style={{ fontWeight: 600, color: '#666' }}>
        //                     {index + 1}
        //                 </div>
        //             )
        //         }
        //     },
        //     {
        //         title: 'Action',
        //         key: 'operation',
        //         width: 120,
        //         render: (text, record) => (
        //             <React.Fragment>
        //                 <Tooltip title="Approve Request">
        //                     <Button
        //                         loading={loading}
        //                         shape="circle"
        //                         icon="check"
        //                         size="small"
        //                         type="primary"
        //                         onClick={() =>
        //                             this.updateRequestStatus(record._id, "Approved")
        //                         }
        //                     />
        //                 </Tooltip>

        //                 <Tooltip title="Disapprove Request">
        //                     <Button
        //                         loading={loading}
        //                         shape="circle"
        //                         icon="close"
        //                         size="small"
        //                         type="danger"
        //                         style={{ marginLeft: '8px' }}
        //                         onClick={() =>
        //                             this.updateRequestStatus(record._id, "Disapproved")
        //                         }
        //                     />
        //                 </Tooltip>

        //             </React.Fragment>
        //         )
        //     },
        //     {
        //         title: 'Invoice Details',
        //         key: 'invoiceDetails',
        //         searchTextName: 'Invoice Details',
        //         width: 280,
        //         render: (text, record) => {
        //             var invNum = record && record.invoiceNumber ? record.invoiceNumber : '-';
        //             var invType = record && record.invoiceType ? record.invoiceType : '-';
        //             var invStatus = record && record.invoiceStatus ? record.invoiceStatus : 'PENDING';
        //             var approvalStatus = record && record.invoiceApprovalStatus ? record.invoiceApprovalStatus : '-';
        //             var commissionGrandTotal = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;

        //             // Target dynamic base currency extraction setup safely
        //             var invoiceCurrency = record && record.currency ? record.currency : 'EUR';
        //             var invoiceSymbol = currencySymbols[invoiceCurrency] ? currencySymbols[invoiceCurrency] : invoiceCurrency + ' ';

        //             // Audit user logging info variables mapping
        //             var createdUser = record && record.createdByUser ? record.createdByUser : null;
        //             var createdByName = createdUser && createdUser.name ? createdUser.name : '-';

        //             var invDate = record && record.invoiceGeneratedDate ? record.invoiceGeneratedDate : null;
        //             // Parse database dates whether they are nested Mongo $date objects or standard strings
        //             var formattedGenDate = '-';
        //             if (invDate) {
        //                 var rawGenDate = invDate.$date ? invDate.$date : invDate;
        //                 formattedGenDate = moment(rawGenDate).format('DD.MM.YYYY');
        //             }

        //             // ✅ Extracting Term metrics safely from the first internal student invoice structure
        //             var targetInvoices = record && record.invoices ? record.invoices : [];
        //             var termText = '';
        //             if (targetInvoices.length > 0) {
        //                 var firstInv = targetInvoices[0];
        //                 var currentTerm = firstInv.termNumber ? firstInv.termNumber : '1';
        //                 var totalTerms = firstInv.inquiry && firstInv.inquiry.totalTerms ? firstInv.inquiry.totalTerms : '1';
        //                 termText = 'T' + currentTerm + ' / T' + totalTerms;
        //             }

        //             // Color badge mappings conditional configuration layout parameters
        //             var getStatusColors = function (currentStatus) {
        //                 var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
        //                 var config = {
        //                     'PENDING': { color: '#d48806', bg: '#fffbe6', border: '#ffe58f' },
        //                     'CLEARED': { color: '#237804', bg: '#f6ffed', border: '#95de64' },
        //                     'APPROVED': { color: '#389e0d', bg: '#f6ffed', border: '#b7eb8f' },
        //                     'PAID BY UNI': { color: '#531dab', bg: '#f9f0ff', border: '#d3adf7' }
        //                 };
        //                 return config[s] || { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' };
        //             };

        //             var mainStatusStyles = getStatusColors(invStatus);
        //             var approvalStyles = getStatusColors(approvalStatus);

        //             return (
        //                 <div style={{
        //                     padding: '12px 14px',
        //                     background: '#fff',
        //                     borderRadius: '10px',
        //                     border: '1px solid #f0f0f0',
        //                     boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
        //                     display: 'flex',
        //                     flexDirection: 'column',
        //                     gap: '10px'
        //                 }}>
        //                     {/* HEADER ROW: INVOICE ID & GENERATION DATE */}
        //                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        //                         <span style={{ fontWeight: 700, fontSize: '13px' }}>
        //                             {record.invoiceUrl ? (
        //                                 <a
        //                                     href={`${MEDIA_URL}${record.invoiceUrl}`}
        //                                     target="_blank"
        //                                     rel="noopener noreferrer"
        //                                     style={{ color: '#096dd9', borderBottom: '1px dashed #096dd9', textDecoration: 'none' }}
        //                                 >
        //                                     Inv#: {invNum}
        //                                 </a>
        //                             ) : (
        //                                 "Inv#: " + invNum
        //                             )}
        //                         </span>
        //                         <div style={{
        //                             fontSize: '11px',
        //                             color: '#595959',
        //                             background: '#f5f5f5',
        //                             padding: '3px 8px',
        //                             borderRadius: '4px',
        //                             border: '1px solid #e8e8e8'
        //                         }}>
        //                             <Icon type="calendar" style={{ marginRight: 5, color: '#8c8c8c' }} />
        //                             {formattedGenDate}
        //                         </div>
        //                     </div>

        //                     {/* BODY SECTION: FINANCIAL METRICS & BADGES SEGMENTATION */}
        //                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        //                         <div>
        //                             {/* Grand total tracking item indicator parameter metrics */}
        //                             <div style={{ fontSize: '16px', fontWeight: 800, color: '#141414', lineHeight: 1.2 }}>
        //                                 {invoiceSymbol}{Number(commissionGrandTotal).toFixed(2)}
        //                             </div>
        //                             <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
        //                                 <span>Type: <strong style={{ color: '#595959' }}>{invType}</strong></span>
        //                                 {/* ✅ Term Tracker Print row elements injection matching T1 / T2 format */}
        //                                 {termText && (
        //                                     <span><strong style={{ color: '#096dd9', background: '#e6f7ff', padding: '1px 4px', borderRadius: '3px', border: '1px solid #91d5ff', fontSize: '10px' }}>{termText}</strong></span>
        //                                 )}
        //                             </div>
        //                         </div>

        //                         {/* Badges block grouping stacked pattern layout elements */}
        //                         <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
        //                             {/* 1. Main Workflow Status */}
        //                             <span style={{
        //                                 fontSize: '10px',
        //                                 fontWeight: 700,
        //                                 color: mainStatusStyles.color,
        //                                 background: mainStatusStyles.bg,
        //                                 border: '1px solid ' + mainStatusStyles.border,
        //                                 padding: '1px 8px',
        //                                 borderRadius: '12px',
        //                                 textTransform: 'uppercase',
        //                                 letterSpacing: '0.3px'
        //                             }}>
        //                                 {invStatus}
        //                             </span>

        //                             {/* 2. Management Approval Status Tag */}
        //                             <span style={{
        //                                 fontSize: '10px',
        //                                 fontWeight: 600,
        //                                 color: approvalStyles.color,
        //                                 background: approvalStyles.bg,
        //                                 border: '1px dashed ' + approvalStyles.border,
        //                                 padding: '1px 6px',
        //                                 borderRadius: '4px',
        //                                 textTransform: 'capitalize'
        //                             }}>
        //                                 Appr: {approvalStatus}
        //                             </span>
        //                         </div>
        //                     </div>

        //                     {/* FOOTER AUDIT LOGGER BLOCK: SYSTEM TRACE STAMPS */}
        //                     <div style={{
        //                         marginTop: '4px',
        //                         paddingTop: '8px',
        //                         borderTop: '1px solid #f5f5f5',
        //                         display: 'flex',
        //                         justifyContent: 'space-between',
        //                         fontSize: '11px',
        //                         color: '#8c8c8c'
        //                     }}>
        //                         <div>
        //                             <Icon type="user" style={{ marginRight: 4, color: '#bfbfbf' }} />
        //                             By: <span style={{ color: '#595959', fontWeight: 500 }}>{createdByName}</span>
        //                         </div>
        //                     </div>
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Student Details',
        //         key: 'studentDetails',
        //         searchTextName: 'Student Details',
        //         width: 220,
        //         render: (text, record) => (
        //             <div>
        //                 {record.invoices && record.invoices.length > 0 ? (
        //                     record.invoices.map((student, index) => (
        //                         <div
        //                             key={index}
        //                             style={{
        //                                 marginBottom: '14px',
        //                                 paddingBottom: '10px',
        //                                 borderBottom:
        //                                     index !== record.invoices.length - 1
        //                                         ? '1px solid #f0f0f0'
        //                                         : 'none',
        //                                 lineHeight: '22px'
        //                             }}
        //                         >
        //                             <div
        //                                 style={{
        //                                     fontWeight: 700,
        //                                     color: '#1677ff',
        //                                     fontSize: '15px'
        //                                 }}
        //                             >
        //                                 {student.studentName}
        //                             </div>

        //                             <div>
        //                                 <b>VID:</b> {student.studentVisionId} |
        //                                 <b> PPT:</b> {student.passportNumber}
        //                             </div>

        //                             <div>
        //                                 <b>ID:</b> {student.instituteStudentId}
        //                             </div>

        //                             <div>
        //                                 <b>Email:</b> {student.studentEmail}
        //                             </div>

        //                             <div>
        //                                 <b>Mobile:</b> {student.studentMobile}
        //                             </div>

        //                             <div style={{ color: '#666' }}>
        //                                 <b>Branch:</b> {student.studentBranchName}
        //                             </div>
        //                         </div>
        //                     ))
        //                 ) : (
        //                     <div>-</div>
        //                 )}
        //             </div>
        //         )
        //     },

        //     {
        //         title: 'University / Course',
        //         searchTextName: 'University/Course Details',
        //         key: 'universityDetails',
        //         width: 250,
        //         render: (text, record) => (
        //             <div>
        //                 {record.invoices && record.invoices.length > 0 ? (
        //                     record.invoices.map((student, index) => (
        //                         <div
        //                             key={index}
        //                             style={{
        //                                 marginBottom: '14px',
        //                                 paddingBottom: '10px',
        //                                 borderBottom:
        //                                     index !== record.invoices.length - 1
        //                                         ? '1px solid #f0f0f0'
        //                                         : 'none',
        //                                 lineHeight: '22px'
        //                             }}
        //                         >
        //                             <div
        //                                 style={{
        //                                     fontWeight: 700,
        //                                     color: '#434343',
        //                                     fontSize: '15px'
        //                                 }}
        //                             >
        //                                 {student.universityInstitutionName}
        //                             </div>

        //                             <div>{student.courseName}</div>

        //                             <div>
        //                                 <b>Start:</b>{' '}
        //                                 {student.courseStartDate
        //                                     ? moment(student.courseStartDate).format(
        //                                         'DD.MM.YYYY'
        //                                     )
        //                                     : '-'}
        //                             </div>

        //                             <div>
        //                                 <b>Tuition Fee:</b> {student.tutionFee}{' '}
        //                                 {student.currency}
        //                             </div>

        //                             <div>
        //                                 <b>Commission:</b>{' '}
        //                                 {student.commissionTotal}{' '}
        //                                 {student.currency}
        //                             </div>
        //                         </div>
        //                     ))
        //                 ) : (
        //                     <div>-</div>
        //                 )}
        //             </div>
        //         )
        //     },

        //     {
        //         title: 'Company Details',
        //         searchTextName: 'Company Details',
        //         key: 'companyDetails',
        //         width: 220,
        //         render: (text, record) => (
        //             <div style={{ lineHeight: '22px' }}>
        //                 <div
        //                     style={{
        //                         fontWeight: 700,
        //                         fontSize: '15px',
        //                         color: '#434343'
        //                     }}
        //                 >
        //                     {record.invoiceToName}
        //                 </div>

        //                 <div>
        //                     <b>CP:</b> {record.kindAttention}
        //                 </div>

        //                 <div>
        //                     <b>Email:</b> {record.invoiceToEmail}
        //                 </div>

        //                 <div>
        //                     <b>Phone:</b> {record.invoiceToPhone}
        //                 </div>

        //                 <div>
        //                     <b>Category:</b> {record.invoiceToCategory}
        //                 </div>
        //             </div>
        //         )
        //     }
        // ];
        return (
            <Drawer
                title={`Invoice Approval Requests:-${count}`}
                width={1000}
                placement="right"
                visible={visible}
                closable={true}
                onClose={this.onClose}
            >
                <Card bordered={true}>
                    <Alert
                        message="Final Quality Check & Verification Required"
                        description={
                            <ul style={{ paddingLeft: '15px', marginBottom: 0 }}>
                                <li><strong>Final Invoice Structure:</strong> These invoices are ready to be dispatched. Please perform a rigorous check on the totals, breakdown amounts, and structural formatting before hitting approve.</li>
                                <li><strong>Verify Recipient Details:</strong> Double-check the <strong>University</strong> or <strong>Channel Partner (CP)</strong> name, address, attention details, and email addresses to ensure data accuracy.</li>
                                <li><strong>Post-Approval Action:</strong> After your approval, this invoice will be submitted to the university or CP.</li>
                            </ul>
                        }
                        type="warning"
                        showIcon
                        style={{ marginBottom: '20px' }}
                    />
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        rowKey={(record) => {
                            return record._id + "_" + record.invoiceGeneratedRecordId;
                        }}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: 200,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </Drawer>
        )
    }
}

export default InvoiceApprovalDrawer;